import httpBuildQuery from 'http-build-query';
import API from './api';

export default {
    getLocations() {
        return API.get('locations')
        .then((res) => {
            const result = res.data;
            return result;
        });
    },
    addLocation(formdata) {
        return API.post('addlocation', httpBuildQuery(formdata))
        .then((res) => {
            const result = res.data;
            return result;
        });
    },
    editLocation(formdata) {
        return API.post('editLocation', httpBuildQuery(formdata))
        .then((res) => {
            const result = res.data;
            return result;
        });
    },
    getLocationInfo(id) {
        return API.get(`getLocationInfo/id/${id}`)
        .then(res => (res.data));
    },
    updateLocationStatus(id, status) {
        return API.get(`updateLocationStatus/id/${id}/status/${status}`).then((res) => {
            const result = res.data;
            return result;
        });
    },
};
